import type { BiomeDef, BiomeId } from './types';

/**
 * Tabela BIOME_TYPE_MODIFIERS (BR-U4-05).
 * Cada bioma tem multiplicador de decay por tipo elemental.
 * 1.0 = neutro; > 1 = decay acelerado (sofre); < 1 = resistência (gosta).
 */
export const BIOMES: Readonly<Record<BiomeId, BiomeDef>> = {
  meadow: {
    id: 'meadow',
    exposure: { Fire: 1.0, Water: 1.0, Earth: 0.8, Air: 1.0, Life: 0.7, Shadow: 1.2 },
  },
  forest: {
    id: 'forest',
    exposure: { Fire: 1.3, Water: 0.9, Earth: 0.9, Air: 0.8, Life: 0.6, Shadow: 1.0 },
  },
  cave: {
    id: 'cave',
    exposure: { Fire: 1.1, Water: 1.0, Earth: 0.7, Air: 1.4, Life: 1.3, Shadow: 0.8 },
  },
  coast: {
    id: 'coast',
    exposure: { Fire: 1.4, Water: 0.6, Earth: 1.0, Air: 1.0, Life: 0.9, Shadow: 1.1 },
  },
};
